import {combineReducers} from "assecobs-faktor-web-common/index";
import {reducer as loginFormReducer} from 'redux-form'

export default combineReducers({
    form: loginFormReducer
});
